export default "__VITE_ASSET__2fa3144c__"